import {
  statement,
  statementGroup,
} from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const fetchTaxStatements = gql`
  query fetchTaxStatements {
    taxStatements {
      id
      title
      year
      statements {
        ...statement
      }
      groups {
        ...statementGroup
      }
    }
  }
  ${statement}
  ${statementGroup}
`;

export default fetchTaxStatements;
